const defaultLocationsColumns = {
  motivation: {
    key: 'motivation',
    label: 'motivation',
    type: 'text',
    sortable: 'custom',
    minWidth: 200,
  },
  location: {
    key: 'location.name',
    label: 'location',
    type: 'text',
    sortable: 'custom',
    minWidth: 200,
  },
  legalConstraint: {
    label: 'legalConstraint',
    type: 'boolean',
    minWidth: 110,
    fixed: true,
    sortable: false,
    align: 'center',
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: true,
    align: 'center',
    minWidth: 100,
    buttons: [
      {
        name: 'editLocation',
        icon: 'fas fa-pencil',
        permissions: ['analysisLocationsManage'],
      },
      {
        name: 'deleteLocation',
        icon: 'fas fa-trash-alt',
        permissions: ['analysisLocationsManage'],
      },
    ],
  },
};

export default defaultLocationsColumns;
